var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle2, _path30, _path31, _path32, _path33, _path34, _path35, _circle3, _path36, _circle4, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStockMarket = function SvgStockMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    "aria-hidden": "true",
    clipRule: "evenodd",
    viewBox: "0 0 320 187"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#def7ec",
    d: "M13.5 27.5h306v141h-306z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.5 117V80.5h13V117z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M36 80.5h6.5V117H36m0-36.5h-6.5V117H36m0-36.5V72m0 45v17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232 97v36.5h13V97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M238.5 133.5h6.5V97h-6.5m0 36.5H232V97h6.5m0 36.5v4.5m0-41V80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116 117.275V90h13v27.275z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M129 117.275h-13V90h13zm-6.5 0V124"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M290 80.736V104h13V80.736z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M303 80.736h-13V104h13zm-6.5 0V75"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M203 119.505V81h13v38.505z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M216 119.505h-13V81h13zm-6.5 0V129"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158 56.714V88h-13V56.714z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M145 56.714h13V88h-13zm6.5 0V49"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#84e1bc",
    d: "M58 60.165V95.72h13V60.165z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M64.5 95.72H71V60.165h-6.5m0 35.555H58V60.165h6.5m0 35.555V104m0-43.835V53"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#84e1bc",
    d: "M261 120.323V67.339h13v52.984z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M267.5 67.339h6.5v52.984h-6.5m0-52.984H261v52.984h6.5m0-52.984V55m0 65.323V125"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#84e1bc",
    d: "M187 120.323V67.339h-13v52.984z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M180.5 67.339H174v52.984h6.5m0-52.984h6.5v52.984h-6.5m0-52.984V55m0 65.323V138.5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87 67.677v52.984h13V67.677z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M93.5 120.661h6.5V67.677h-6.5m0 52.984H87V67.677h6.5m0 52.984V133m0-65.323V43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "M13.5 27.5h306v141h-306z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M40 143h38v40H40z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M40 143h38v12H40z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 168,
    r: 8.5,
    fill: "#18191b",
    stroke: "#18191b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    stroke: "#18191b",
    d: "m57.809 159.613-.133.021c-.811.135-1.885.404-2.952.938s-2.117 1.324-2.902 2.502c-.783 1.175-1.322 2.763-1.322 4.926s.539 3.751 1.322 4.926c.785 1.178 1.836 1.969 2.902 2.502 1.067.534 2.141.803 2.952.938l.133.021a18 18 0 0 1-1.235-1.761C55.55 172.957 54.5 170.615 54.5 168s1.05-4.957 2.074-6.626c.438-.713.876-1.31 1.235-1.761z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M94 143h38v40H94z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M94 143h38v12H94z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    stroke: "#18191b",
    d: "M104.5 168c0 2.163.539 3.751 1.322 4.926.785 1.178 1.836 1.969 2.902 2.502 1.067.534 2.141.803 2.952.938.325.054.605.087.824.106v-16.944c-.219.019-.499.052-.824.106-.811.135-1.885.404-2.952.938s-2.117 1.324-2.902 2.502c-.783 1.175-1.322 2.763-1.322 4.926z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    stroke: "#18191b",
    d: "M121.5 168c0 2.163-.539 3.751-1.322 4.926-.785 1.178-1.836 1.969-2.902 2.502a10.5 10.5 0 0 1-2.952.938c-.325.054-.605.087-.824.106v-16.944c.219.019.499.052.824.106.811.135 1.885.404 2.952.938s2.117 1.324 2.902 2.502c.783 1.175 1.322 2.763 1.322 4.926z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M148 143h38v40h-38z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M148 143h38v12h-38z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 168,
    r: 8.5,
    fill: "#e5e7eb",
    stroke: "#18191b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M202 143h38v40h-38z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M202 143h38v12h-38z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    stroke: "#18191b",
    d: "M229.5 168c0 2.163-.539 3.751-1.322 4.926-.785 1.178-1.836 1.969-2.902 2.502a10.5 10.5 0 0 1-2.952.938c-.325.054-.605.087-.824.106v-16.944c.219.019.499.052.824.106.811.135 1.885.404 2.952.938s2.117 1.324 2.902 2.502c.783 1.175 1.322 2.763 1.322 4.926z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    stroke: "#18191b",
    d: "M212.5 168c0 2.163.539 3.751 1.322 4.926.785 1.178 1.836 1.969 2.902 2.502 1.067.534 2.141.803 2.952.938.325.054.605.087.824.106v-16.944c-.219.019-.499.052-.824.106-.811.135-1.885.404-2.952.938s-2.117 1.324-2.902 2.502c-.783 1.175-1.322 2.763-1.322 4.926z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M256 143h38v40h-38z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f97386",
    stroke: "#18191b",
    d: "M256 143h38v12h-38z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 168,
    r: 8.5,
    fill: "#18191b",
    stroke: "#18191b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e7eb",
    stroke: "#18191b",
    d: "m276.192 159.613.132.021c.811.135 1.885.404 2.952.938s2.117 1.324 2.902 2.502c.783 1.175 1.322 2.763 1.322 4.926s-.539 3.751-1.322 4.926c-.785 1.178-1.836 1.969-2.902 2.502a10.5 10.5 0 0 1-2.952.938l-.132.021c.358-.451.796-1.048 1.234-1.761 1.024-1.669 2.074-4.011 2.074-6.626s-1.05-4.957-2.074-6.626a18 18 0 0 0-1.234-1.761z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 38,
    r: 32.5,
    fill: "#84e1bc",
    stroke: "#18191b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234 19.625 223.297 38 212 19.625 223.297 17z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M212 19.625 223.297 38 234 19.625m-22 0 11.297 3.15L234 19.625m-22 0L223.297 17 234 19.625"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    d: "M228 29.579 223.294 38 218 29.579 223.294 28z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M218 29.579 223.294 38 228 29.579m-10 0 5.294 1.579L228 29.579m-10 0L223.294 28 228 29.579"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M223.297 38 234 55.889 223.297 61 212 55.889z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca15",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "m223.297 49-8.324 3.36L212 56.2l11.297 4.8L234 56.2l-2.973-4.32z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M223.5 23v38"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    d: "M77.647 20.794a.5.5 0 0 1-1 0v-2.147H74.5a.5.5 0 0 1 0-1h2.147V15.5a.5.5 0 0 1 1 0v2.147h2.147a.5.5 0 0 1 0 1h-2.147zM2.318 108.682a.318.318 0 0 1-.636 0v-1.364H.318a.318.318 0 0 1 0-.636h1.364v-1.364a.318.318 0 0 1 .636 0v1.364h1.364a.318.318 0 0 1 0 .636H2.318z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(1 0 0 -1 3 41)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(1 0 0 -1 7 135)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(1 0 0 -1 12 15)"
  })));
};
export default SvgStockMarket;